const modalDescriptionFunction = {
    modalId: 'modal-description-function',
    preventEscapeKey: false,
    onShowExtra: null,
    onCloseExtra: null,
    setup: null,
};

export default modalDescriptionFunction;
